import { actionClient, restfulClient } from '@/api'

const state = {
    reasons: null,
}

// actions
const actions = {
    async loadReasons({ state, commit }) {
        const data = await actionClient.get('return-order-reason')
        state.reasons = data
    },

    async refundOrder({}, { orderId, reason}) {
        await actionClient.post('member/personal/refund-order', {
            orderId,
            reason
        })
    },

    async refundOrderInfo({}, data) {
       return  await restfulClient.update('member/personal/refund-order', '',  data)
    },

    async loadRefundOrders({}){

    }, 

    async changeRefundOrderStatus({}, { id, status }) {
        await restfulClient.update('member/personal/change-refund-order-status', id, {
            status
        })
    },
}


// mutations
const mutations = {
    
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
